module.exports = __webpack_public_path__ + "img/currency-rupee.52bd4aea.svg";